module.exports = __webpack_public_path__ + "img/woman_grey.6a95a3fa.svg";